import { Slide } from 'pure-react-carousel';
import React from 'react';
import s from './slideStyles';
import Slide5 from './slide_5.svg';

export default ({ index }) => (
    <Slide className={s.slideWrapper} index={index}>
        <div className={s.imageWrapper}>
            <Slide5 />
        </div>
        <div className={s.textWrapper}>
            <p>
                The neural network of virtual experts communicates across
                departments, each’s field and leven of expertise just as in the
                real world where humans combine skills, knowledge, and know-how
                to reach the correct solution.
            </p>
            <p>
                <em>
                    All virtual experts combine forces to find the correct
                    conclusion.
                </em>
            </p>
        </div>
    </Slide>
);



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide5.component.js